"use strict";

exports.__esModule = true;
exports.verifyProperties = verifyProperties;
var _is = require("./is");
function verifyProperties(attrs) {
  if (!(0, _is.isObject)(attrs)) {
    return;
  }
  var copyAttrs = Object.assign({}, attrs);
  Object.keys(copyAttrs).forEach(function (key) {
    var val = copyAttrs[key];
    // 验证 key 长度
    if (key.length > 50) {
      var shortKey = key.substring(0, 50);
      copyAttrs[shortKey] = val;
      delete copyAttrs[key];
      key = shortKey;
    }
    // 验证 value 类型和长度
    if (!(0, _is.isString)(val) && !(0, _is.isNumber)(val)) {
      delete copyAttrs[key];
    } else if ((0, _is.isString)(val) && val.length > 2e3) {
      copyAttrs[key] = val.substring(0, 2e3);
    }
  });
  var keys = Object.keys(copyAttrs);
  if (!keys.length) {
    return;
  }
  if (keys.length > 20) {
    keys.forEach(function (key, index) {
      if (index > 19) {
        delete copyAttrs[key];
      }
    });
  }
  return copyAttrs;
}